import React, { useState, useEffect } from "react";
import {
  Modal,
  Form,
  Input,
  Select,
  Upload,
  Button,
  Image,
  message,
} from "antd";
import callApi from "../../constants/API/CallApi";
import { ShowToast, Severty } from "../../helper/toast";
import {
  updateBelt,
  getBelt,
  ListClass,
  editBanner,
  getBanner,
  getBranches,
} from "../../constants/API/API";
import useApi from "../../hooks/useApi";
import { UploadOutlined } from "@ant-design/icons";
import { uploadFileToS3 } from "../../helper/uploadImage";

const allowedImageTypes = ["image/png", "image/jpeg", "image/webp"];

const UpdateBanner = ({
  editVisible,
  setEditVisible,
  selectedBelt,
  refresh,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState([]);
  const [branches, setBranches] = useState([]);

  useEffect(() => {
    if (selectedBelt) {
      getBanner(selectedBelt._id)
        .then((response) => {
          if (response.status === 200 && response.data) {
            form.setFieldsValue({
              image: response.data.image,
              link: response.data.link,
              title: response.data.title,
              branchId: response.data.branchId,
            });
            let fileData = {
              uid: 1,
              name: "image",
              status: "done",
              url: response.data?.image,
              thumbUrl: response.data?.image,
            };
            setFile([fileData]);
          }
        })
        .catch((err) => {
          ShowToast(err.message || "Failed to fetch belt data", Severty.ERROR);
        });
    }
  }, [selectedBelt, form]);

  useApi({
    callback: getBranches,
    dependencies: [refresh],
    shouldCallApi: true,
    onSuccess: ({ data }) => {
      const activeBranches = (data || []).filter((branch) => branch.isActive);
      setBranches(activeBranches);
    },
  });

  const handleOk = async (values) => {
    setLoading(true);
    callApi({
      callback: () => editBanner({ ...values }, selectedBelt?._id),
      payload: {},
      onSuccess: ({ message }) => {
        ShowToast(message, Severty.SUCCESS);
        form.resetFields();
        refresh((x) => !x);
        setEditVisible(false);
        setLoading(false);
      },
      onError: (err) => {
        ShowToast(err, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  const handleCancel = () => {
    setEditVisible(false);
    form.resetFields();
  };

  const beforeUpload = (file, type) => {
    const validTypes = allowedImageTypes;
    if (!validTypes.includes(file.type)) {
      message.error("Unsupported file type.");
      return Upload.LIST_IGNORE;
    }
    if (file.size / 1024 / 1024 > 100) {
      message.error("File must be smaller than 100MB.");
      return Upload.LIST_IGNORE;
    }
    return true;
  };

  const handleFileUpload = async (info) => {
    const { file } = info;
    setLoading(true);
    try {
      const data = await uploadFileToS3({
        file,
        bucketName: "invent-co-new",
        dirName: "event",
      });
      const fileData = {
        uid: file.uid,
        name: file.name,
        status: "done",
        url: data.Location,
        thumbUrl: data.Location,
      };
      setFile([fileData]);
      form.setFieldsValue({
        image: data.Location,//`${process.env.REACT_APP_AWS_S3_ENDPOINT}/${process.env.REACT_APP_AWS_S3_BUCKET_NAME}/` + data.Key,
      });
    } catch (error) {
      console.error(error);
      message.error("Upload failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={editVisible}
      className="tab_modal"
      title="Update Banner"
      okText="Update"
      onCancel={handleCancel}
      okButtonProps={{
        form: "update-belt",
        htmlType: "submit",
        loading: loading,
      }}
      width={600}
      destroyOnClose
    >
      <Form
        id="update-belt"
        form={form}
        onFinish={handleOk}
        layout="vertical"
        preserve={false}
      >
        <Form.Item
          name="title"
          label="Banner Title"
          rules={[{ required: true, message: "Title is required" }]}
          normalize={(v) => v?.trimStart()}
        >
          <Input placeholder="Enter banner title" />
        </Form.Item>

        <Form.Item
          name="link"
          label="Banner Link"
          // rules={[{ required: true, message: "Please enter a banner link" }]}
          normalize={(v) => v?.trimStart()}
        >
          <Input placeholder="Enter banner link" />
        </Form.Item>

        <Form.Item
          name="branchId"
          label="Branch"
          rules={[{ required: true, message: "Please select branch!" }]}
        >
          <Select placeholder="Select Branch">
            {branches?.map((branch) => (
              <Select.Option key={branch?._id} value={branch?._id}>
                {branch?.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item name="image" label="Upload Banner Image">
          <Upload
            listType="picture"
            maxCount={1}
            beforeUpload={(file) => beforeUpload(file)}
            customRequest={(info) => handleFileUpload(info)}
            fileList={file}
            onRemove={() => {
              setFile([]);
            }}
          >
            {file.length < 1 && (
              <Button icon={<UploadOutlined />}>Upload Banner Image</Button>
            )}
          </Upload>
          {file.length > 0 && (
            <div className="mt-2">
              <Image width={100} src={file[0].url} />
            </div>
          )}
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default UpdateBanner;
